// ======================= Imports =======================
import React from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

// ======================= Stripe Initialization =======================
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

// ======================= Stripe Provider Component =======================
export const StripeProvider = ({ children }) => {
  return <Elements stripe={stripePromise}>{children}</Elements>;
};
